import cookies from 'js-cookie';
import { COOKIE_TESTING_KEY } from '@motionelements/core/src/app.constants.js';

// eslint-disable-next-line
export default () => {
  return !!cookies.get(COOKIE_TESTING_KEY);
};
